// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="100%"
    height="100%"
    viewBox="0 0 216 135"
    {...props}
  >
    <path
      d="M0.25 6C0.25 2.82436 2.82436 0.25 6 0.25H210C213.176 0.25 215.75 2.82436 215.75 6V129C215.75 132.176 213.176 134.75 210 134.75H6C2.82437 134.75 0.25 132.176 0.25 129V6Z"
      fill="#F1F1F3"
      stroke="#F1F1F3"
      strokeWidth={0.5}
    />
    <rect
      x={140}
      y={7}
      width={69}
      height={120}
      rx={6}
      fill="white"
    />
    <rect
      x={7}
      y={7}
      width={127}
      height={71}
      rx={6}
      fill="white"
    />
    <rect
      x={7}
      y={84}
      width={127}
      height={43}
      rx={6}
      fill="white"
    />
    <circle
      cx={174.5}
      cy={32.5}
      r={17.5}
      fill="#F1F1F3"
    />
    <rect
      x={152}
      y={61}
      width={46}
      height={7}
      rx={3.5}
      fill="#F1F1F3"
    />
    <rect
      x={152}
      y={74}
      width={26}
      height={7}
      rx={3.5}
      fill="#F1F1F3"
    />
    <rect
      x={22}
      y={25}
      width={97}
      height={7}
      rx={3.5}
      fill="#F1F1F3"
    />
    <rect
      x={22}
      y={38}
      width={56.3226}
      height={7}
      rx={3.5}
      fill="#F1F1F3"
    />
  </svg>
);
const SvgDefaultDemoScreenshot = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgDefaultDemoScreenshot;
